// Ermittelt die Tabellenzeilen aus der Ausgabe eines MCP-Tool-Aufrufs im KI-Chat ("Visualize Raw Data").
// Die Tools liefern drei Formen:
//   DataForSEO (.ai-Format):  { id, status_code, status_message, items: [...] }
//   Quaro, Liste direkt:      { data: [...], meta }
//   Quaro, Liste im Objekt:   { data: { total, count, rows|keywords|projects|competitors|...: [...] }, meta }
// Bisher wurde nur `items` gelesen - bei allen Quaro-Tools kam dadurch nichts an (POST /mcp/tabledef -> 400
// "No output provided"). Gibt die Zeilen und den Pfad zurück, unter dem sie gefunden wurden.
function isRowList(value) {
    return Array.isArray(value) && value.length > 0 && value.every((row) => row && typeof row === "object" && !Array.isArray(row))
}

function isPlainObject(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value)
}

export function extractTableRows(output) {
    if (!output || typeof output !== "object") return { rows: [], path: null }
    if (isRowList(output)) return { rows: output, path: "" }
    if (isRowList(output.items)) return { rows: output.items, path: "items" }

    let data = output.data
    let base = "data"
    if (isRowList(data)) return { rows: data, path: "data" }

    // Hülle mit genau einem Schlüssel (data.credits, data.workflow, data.briefing): eine Ebene tiefer weitersuchen
    if (isPlainObject(data) && Object.keys(data).length === 1 && isPlainObject(Object.values(data)[0])) {
        base = "data." + Object.keys(data)[0]
        data = Object.values(data)[0]
    }

    if (data && typeof data === "object" && !Array.isArray(data)) {
        // Die längste Liste von Objekten im data-Objekt (rows, keywords, projects, ...). Listen aus Strings wie
        // platforms: ["chat_gpt", ...] sind Metadaten, keine Tabellenzeilen.
        let best = null
        for (const [key, value] of Object.entries(data)) {
            if (isRowList(value) && (!best || value.length > best.rows.length)) best = { rows: value, path: base + "." + key }
        }
        if (best) return best

        // Keine Liste, aber ein Objekt aus gleichartigen Unterobjekten (z. B. Credits je Suite):
        // eine Zeile je Schlüssel.
        const entries = Object.entries(data)
        if (entries.length && entries.every(([, value]) => isPlainObject(value))) {
            return { rows: entries.map(([name, value]) => ({ name, ...value })), path: base + ".*" }
        }

        // Letzte Möglichkeit: Einzelwerte als Schlüssel/Wert-Tabelle (z. B. audit_page-Checks, Datenstand).
        // Ein Unterobjekt aus Einzelwerten (checks: { is_4xx: true, ... }) wird eine Ebene aufgeklappt.
        const pairs = []
        for (const [name, value] of entries) {
            if (isPlainObject(value)) {
                for (const [sub, subValue] of Object.entries(value)) {
                    if (subValue === null || typeof subValue !== "object") pairs.push({ name: name + "." + sub, value: subValue })
                }
            } else if (value === null || typeof value !== "object") {
                pairs.push({ name, value })
            }
        }
        if (pairs.length) return { rows: pairs, path: base + " (Werte)" }
    }
    return { rows: [], path: null }
}
